import { useLocation } from 'react-router-dom';
import type { RecordContext } from '../types/assistant.types';

// Routes verified against src/core/router/paths.ts. Types match the backend router _CONTEXT_MAP.
const RULES: { re: RegExp; type: string; label: (id: string) => string }[] = [
  { re: /\/leads\/(\d+)/, type: 'lead', label: (id) => `Lead #${id}` },
  {
    re: /\/submissions\/(\d+)/,
    type: 'submission',
    label: (id) => `Submission #${id}`,
  },
  {
    re: /\/participants\/edit\/(\d+)/,
    type: 'participant',
    label: (id) => `Participant #${id}`,
  },
  {
    re: /\/accounting\/invoices\/edit\/(\d+)/,
    type: 'invoice',
    label: (id) => `Invoice #${id}`,
  },
  {
    re: /\/accounting\/payments\/edit\/(\d+)/,
    type: 'payment',
    label: (id) => `Payment #${id}`,
  },
];

export function detectRecordContext(pathname: string): RecordContext | null {
  for (const r of RULES) {
    const m = pathname.match(r.re);
    if (m) return { type: r.type, id: Number(m[1]), label: r.label(m[1]) };
  }
  return null;
}

export function useRecordContext(): RecordContext | null {
  const { pathname } = useLocation();
  return detectRecordContext(pathname);
}
